
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import ContactCard from "../components/ContactCard"
import WriteUsForm from "../components/WriteUsForm";
import Header from "../Header";
import Footer from "../Footer";
import ScrollButtons from "../ScrollButtons";
// import "../index.ccs";

const App = () => {
  return (
    <div>
    <Header/>
    <ScrollButtons/>
    <div className="app-container d-flex justify-content-center align-items-center mt-5">
      <div className="card-container d-flex flex-wrap">
        <ContactCard />
      </div>
      <div className="card-container d-flex flex-wrap">
      <WriteUsForm/>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default App;
